import { IsArray, IsDefined } from 'class-validator';

export class GetAssemblyLocationLabelsResponse {
    @IsDefined()
    @IsArray()
    public values: (string | null)[];

    constructor(data?: Partial<GetAssemblyLocationLabelsResponse>) {
        this.values = data?.values;
    }
}
